import React from 'react';
import { FormattedMessage } from 'react-intl';

const googleErrors = () => {
  return <FormattedMessage
    id='shared_components.login_manager.login_using_google_account'
    defaultMessage='Looks like you already have an account with us. Please log in using your Google account.'
  />;
};

const appleErrors = () => {
  return <FormattedMessage
    id='shared_components.login_manager.login_using_apple_account'
    defaultMessage='Looks like you already have an account with us. Please log in using your Apple account.'
  />;
};

const emailErrors = () => {
  return <FormattedMessage
    id='shared_components.login_manager.already_have_account'
    defaultMessage='Looks like you already have an account with us. Please log in using your email and password.'
  />;
};

const facebookErrors = () => {
  return <FormattedMessage
    id='shared_components.login_manager.login_using_facebook_account'
    defaultMessage='Looks like you already have an account with us. Please log in using your Facebook account.'
  />;
};

const generalError = () => {
  return <FormattedMessage
    id='shared_components.signup_form.refresh_error'
    defaultMessage='Something went wrong, please try again. If the problem persists please refresh.'
  />;
};

const noLoginErrors = () => {
  return <FormattedMessage
    id='shared_components.login_manager.incorrect_email_password'
    defaultMessage='Email and password combination is incorrect.'
  />;
};

const invalidEmailOrPass = () => {
  return <FormattedMessage
    id="shared_components.login_manager.enter_valid_email_password"
    defaultMessage="Please enter a valid email and password."
  />;
};

export const handleError = (errorDescription) => {
  let error = '';
  if (errorDescription === 'Invalid Password') {
      error = SignupErrors('password');
  } else if (errorDescription === 'Invalid grant: user credentials are invalid') {
      error = SignupErrors('invalid');
  } else {
      error = SignupErrors('general');
  }
  return error;
};


export const SignupErrors = (type) => {
  let errMsg;
  switch (type) {
  case 'google':
    errMsg = googleErrors();
    break;
  case 'facebook':
    errMsg = facebookErrors();
    break;
  case 'apple':
    errMsg = appleErrors();
    break;
  case 'email':
    errMsg = emailErrors();
    break;
  case 'password':
    errMsg = noLoginErrors();
    break;
  case 'invalid':
    errMsg = invalidEmailOrPass();
    break;
  default:
    errMsg = generalError();
  }
  return errMsg;
};
